import { useToastStore } from '@/store/useToastStore';
import type { ToastTone } from '@/store/useToastStore';
import { cn } from '@/lib/cn';

const TONE_CLASSES: Record<ToastTone, string> = {
  success: 'border-success/30 bg-success-soft text-success',
  error: 'border-danger/30 bg-danger-soft text-danger',
  info: 'border-info/30 bg-info-soft text-info',
};

export function Toaster() {
  const toasts = useToastStore((state) => state.toasts);
  const dismiss = useToastStore((state) => state.dismiss);

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-[60] flex w-80 flex-col gap-2">
      {toasts.map((toastItem) => (
        <div
          key={toastItem.id}
          role="status"
          className={cn(
            'flex animate-fade-in items-start justify-between gap-3 rounded-lg border px-4 py-3 text-sm font-medium shadow-pop',
            TONE_CLASSES[toastItem.tone],
          )}
        >
          <span>{toastItem.message}</span>
          <button
            type="button"
            aria-label="Dismiss"
            onClick={() => dismiss(toastItem.id)}
            className="text-current opacity-60 hover:opacity-100"
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}
